import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

/**
 * Scene 54 — Future Hero. Cinematic dark stage that anchors the section's
 * opening question. The photo and the "SECTION 8" tag have been moved to
 * the next slide so this opener stays clean and breath-taking.
 */

export default function Scene54_FutureHero() {
  return (
    <section
      className="absolute inset-0 overflow-hidden"
      data-testid="scene-future-hero"
    >
      {/* Dark cinematic backdrop with slow gold breath */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 30% 70%, rgba(212,148,10,0.12) 0%, transparent 60%)",
            "radial-gradient(ellipse at 70% 30%, rgba(233,168,32,0.20) 0%, transparent 60%)",
            "radial-gradient(ellipse at 30% 70%, rgba(212,148,10,0.12) 0%, transparent 60%)",
          ],
        }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
        style={{ background: "rgba(7,18,12,1)" }}
      />
      {/* Subtle grain */}
      <div className="absolute inset-0 grain pointer-events-none opacity-30" />

      {/* Eyebrow */}
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.6 }}
        className="absolute top-12 left-1/2 -translate-x-1/2 kn-eyebrow flex items-center gap-3 z-10"
      >
        <Sparkles className="w-3.5 h-3.5" style={{ color: "#e9a820" }} />
        The future
      </motion.div>

      {/* Hero text — centred for cinematic breath */}
      <motion.div
        initial={{ opacity: 0, y: 32, filter: "blur(12px)" }}
        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: 1.4, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 flex items-center justify-center px-8 z-10"
        data-testid="future-hero-headline"
      >
        <h2
          className="kn-display text-5xl sm:text-7xl lg:text-[110px] leading-[0.95] text-center max-w-[1400px]"
          style={{
            color: "#ffffff",
            textShadow: "0 4px 60px rgba(0,0,0,0.85)",
            fontWeight: 900,
          }}
        >
          What does the
          <br />
          <span
            style={{
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            future
          </span>{" "}
          look like?
        </h2>
      </motion.div>

      {/* Bottom-right decorative caption */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.55 }}
        transition={{ duration: 1.2, delay: 2.0 }}
        className="absolute bottom-12 right-12 text-xs tracking-[0.32em] uppercase italic z-10"
        style={{ color: "rgba(255,255,255,0.6)" }}
      >
        not roadmap · already happening
      </motion.div>
    </section>
  );
}
